import React from 'react'
import Helmet from '../Helmet/Helmet';
import CommonSection from '../UI/CommonSection';

const AllCategoris = () => {
  return (
    <Helmet title='All Categories '>
    <CommonSection title={'All Categories'}/>
      <div className='container'>
          <div className='row mt-3'>
              <div className="col-md-12">
                  <div className="card">
                      <h2> All Categories </h2>
                  </div>
              </div>
          </div>
          <div className='row'>
              <div className="col-md-12">
                  <div className="card">
                    <div className='card-header'>  
                        Automotive & Motorbike
                    </div>
                    <div className='row'>
                        <div className="col-md-12">
                          <div className='card-body'> 
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
              </div>
          </div>
          <div className='row'>
              <div className="col-md-12">
                  <div className="card">
                    <div className='card-header'>  
                        Automotive & Motorbike
                    </div>
                    <div className='row'>
                        <div className="col-md-6">
                          <div className='card-body'> 
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className='card-body'> 
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
              </div>
          </div>
          <div className='row'>
              <div className="col-md-12">
                  <div className="card">
                    <div className='card-header'>  
                        Automotive & Motorbike
                    </div>
                    <div className='row'>
                        <div className="col-md-4">
                          <div className='card-body'> 
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className='card-body'> 
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className='card-body'> 
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
              </div>
            
          </div>
          <div className='row'>
              <div className="col-md-12">
                  <div className="card">
                    <div className='card-header'>  
                        Automotive & Motorbike
                    </div>
                    <div className='row'>
                        <div className="col-md-4">
                          <div className='card-body'> 
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className='card-body'> 
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className='card-body'> 
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
              </div> 
          </div>
          <div className='row'>
              <div className="col-md-12">
                  <div className="card">
                    <div className='card-header'>  
                        Automotive & Motorbike
                    </div>
                    <div className='row'>
                        <div className="col-md-3">
                          <div className='card-body'> 
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className='card-body'> 
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className='card-body'> 
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className='card-body'> 
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                            <div className='card-title'>
                                Automotive & Motorbike
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
              </div>
          </div>
      </div>
    </Helmet>
  )
}

export default AllCategoris;